/**
 * @file: index.tsx
 *
 * The inbox `_index` screen — the always-present home of the inbox stack.
 * Mobile renders the home surface (chrome + thread tabs); desktop renders
 * the master-detail columned layout. Both share the same providers from
 * InboxFlow; only the presentation differs.
 */

import { useAIAssistantForPage } from '@euler/app/components/ai/pageContext';
import { useIsDesktopLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { InboxOverlayHost } from '../components/InboxOverlayHost';
import { InboxDesktopLayout } from '../components/desktop-layout';
import { InboxMobileLayout } from '../components/mobile-layout';

export const InboxIndexScreen = wrapNavigatorScreen(
  () => {
    const isDesktop = useIsDesktopLayout();
    // `_index` is a shared home-screen route name, so the nav-based AI page
    // context can't map it to the inbox — push it explicitly here, where it
    // covers both the mobile and desktop home layouts.
    useAIAssistantForPage('inbox');
    // The transient overlay (search / settings / picker) is mounted once for
    // both layouts — its BottomPanel is a sheet on mobile, a card on desktop.
    return (
      <>
        {isDesktop ? <InboxDesktopLayout /> : <InboxMobileLayout />}
        <InboxOverlayHost />
      </>
    );
  },
  { headerShown: false },
);
